import React from 'react';

function SettingsBar({ uiMode, setUiMode, selectedModel, setSelectedModel }) {
  return (
    <div className="settings-bar">
      <div className="settings-group">
        <label>UI Mode:</label>
        <div className="toggle-buttons">
          <button
            className={`toggle-btn ${uiMode === 'simple' ? 'active' : ''}`}
            onClick={() => setUiMode('simple')}
          >
            🎯 Simple
          </button>
          <button
            className={`toggle-btn ${uiMode === 'advanced' ? 'active' : ''}`}
            onClick={() => setUiMode('advanced')}
          >
            ⚙️ Advanced
          </button>
        </div>
      </div>

      {uiMode === 'advanced' && (
        <div className="settings-group">
          <label>AI Model:</label>
          <select
            value={selectedModel}
            onChange={(e) => setSelectedModel(e.target.value)}
            className="model-select"
          >
            <option value="gpt-image-1">DALL-E 3 (OpenAI)</option>
            <option value="nano-banana">Nano Banana Pro (Gemini)</option>
          </select>
        </div>
      )}
    </div>
  );
}

export default SettingsBar;
